import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import Calendario from './Calendario/Calendario';
import ZoomControls from './Calendario/utils/CalendarioZoom';
import { ProcessoUsuarioProvider, useProcessoContext } from '../../Routes/context/ProcessoUsuarioContext';
import { useBreadcrumbs } from '../../Routes/BreadcrumbContext';
import { createBreadcrumbs } from '../../utils/breadcrumbUtils';

const PaginaCronograma: React.FC = () => {
    const { processoId } = useParams<{ processoId: string }>();
    
    if (!processoId) {
        return <div>Processo ID não fornecido</div>;
    }

    return (
        <ProcessoUsuarioProvider processoId={processoId}>
            <PaginaCronogramaContent />
        </ProcessoUsuarioProvider>
    );
};

const PaginaCronogramaContent: React.FC = () => {
    const { processo } = useProcessoContext();
    const [zoomLevel, setZoomLevel] = useState(75);
    const { processoId } = useParams<{ processoId: string }>();
    const navigate = useNavigate();

    const { setBreadcrumbs } = useBreadcrumbs();
    useEffect(() => {
        setBreadcrumbs(createBreadcrumbs.fromProcessos([
            { path: `/processos/${processoId!}/cronograma`, breadcrumb: `Cronograma` },
        ]));
    }, [setBreadcrumbs, processo]);

    return (
        <div className="container-fluid">
            <div className="shadow p-3 mb-5 bg-white rounded">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h1 className="text-center flex-grow-1">Cronograma de {processo?.nome}</h1>
                    <Button 
                        variant="outline-primary" 
                        onClick={() => navigate(`/processos/${processoId}/cronograma/pdf`)}
                    >
                        📄 Gerar PDF
                    </Button>
                </div>
                {processo && <Calendario processoUsuario={processo} zoomLevel={zoomLevel} setZoomLevel={setZoomLevel} />}
            </div>
            <ZoomControls zoomLevel={zoomLevel} setZoomLevel={setZoomLevel} />
        </div>
    );
};

export default PaginaCronograma;
